import { gateway } from "src/gateway";
import type { IInvoice } from "../../../../create/interfaces/invoice.interfaces";

export type InvoiceTipKind = "amount" | "percentage";

export interface SetInvoiceTipPayload {
  invoiceUid: string;
  kind: InvoiceTipKind;
  value: number;
  token?: string | null;
}

export const setInvoiceTip = async ({ invoiceUid, kind, value, token }: SetInvoiceTipPayload): Promise<IInvoice> => {
  const localToken = sessionStorage.getItem("token");
  const response = await gateway.put(
    `/invoices/${invoiceUid}/tip`,
    { kind, value },
    {
      headers: { Authorization: `Bearer ${token || localToken}` },
    },
  );
  return response.data.data;
};
